export default __webpack_public_path__ + "static/media/man.5e3073ba.svg";